export default "__VITE_ASSET__B1_5cn0y__"